function createEmptyListResponse(start = 0, size = 8) {
  return { metadata: { count: 0, size, start }, data: [] };
}

export default {
  createEmptyListResponse,
};
